import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartbeat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.92863 0.500084C6.29751 0.50547 6.619 0.75267 6.71892 1.1078L9.77992 11.9914L11.3864 7.7075C11.5083 7.38225 11.8193 7.16675 12.1667 7.16675H14.6667C15.1269 7.16675 15.5 7.53984 15.5 8.00008C15.5 8.46034 15.1269 8.83342 14.6667 8.83342H12.7442L10.4469 14.9593C10.3204 15.2968 9.99142 15.5146 9.63142 15.4993C9.27142 15.4841 8.962 15.2393 8.86442 14.8923L5.87462 4.26183L4.62873 8.24867C4.52002 8.59659 4.19782 8.83342 3.83333 8.83342H1.33333C0.8731 8.83342 0.5 8.46034 0.5 8.00008C0.5 7.53984 0.8731 7.16675 1.33333 7.16675H3.22067L5.12127 1.08486C5.2313 0.732737 5.55976 0.494879 5.92863 0.500084Z"
	})
});
export default SvgHeartbeat;
